<template>
  <InsightsTableContainer
    tooltip-key="dropoff-table"
    download-id="dropoff-report-table"
    :error="error"
    class="table"
    :empty-data="emptyData || noWidgetData"
    :loading="loading"
    label="Drop-off Data Table"
    :headers="tableHeaders"
    :rows="tableRows"
    :totals="tableTotals"
    :downloading="downloading"
    @download-csv="$emit('download-csv')"
  >
    <template #actions>
      <WarningWithModal
        v-if="showWarning"
        text-key="dropoff-warning"
      />
    </template>
  </InsightsTableContainer>
</template>

<script setup>
import InsightsTableContainer from '@/components/insights/table/InsightsTableContainer.vue';
import WarningWithModal from '@/components/shared/WarningWithModal.vue';
import { computed } from 'vue';
import { isEmpty } from 'lodash-es';

const props = defineProps({
  error: {
    type: Boolean,
    default: false,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  emptyData: {
    type: Boolean,
    default: false,
  },
  data: {
    type: Object,
    default: () => ({}),
  },
  tableRows: {
    type: Array,
    default: () => [],
  },
  tableTotals: {
    type: Array,
    default: () => [],
  },
  downloading: {
    type: Boolean,
    default: false,
  },
});

defineEmits(['download-csv']);

const tableHeaders = [
  'Applied',
  'Screening',
  'Assessment',
  'Offer',
  'Hired',
];

const noWidgetData = computed(() => isEmpty(props.tableRows));

const showWarning = computed(() => {
  const { total, net } = props.data || {};

  const totalApplied = total?.review || 0;
  const netTotalApplied = net?.review || 0;

  if (!totalApplied || !netTotalApplied) return false;

  if (netTotalApplied / totalApplied < 0.7) return true;

  return false;
});
</script>

<style lang="less" scoped>
:deep(.net-dropoff-rate) .table-cell {
  color: @text-brand;
}
</style>
